import { IntranetServiceOrder } from "@/interfaces";
import api from "@/lib/axios";
import { DefaultGetRequestParams, DefaultResponse } from "./types";

export interface StoreServiceOrderRequest {
  service_type: string;
  vehicle_id: number;
  contact: string;
  client_id: number;
  request_date?: string | undefined;
  done?: number | undefined;
  local?: string | undefined;
  total_cost?: number | undefined;
  charge_amount?: number | undefined;
}

export interface UpdateServiceOrderRequest extends StoreServiceOrderRequest {
  id: number;
}

export interface ServiceOrderSharingLink {
  token: string;
  service_order_id: number;
  expires_at: string;
}

export const serviceOrderService = {
  async index({
    page,
    per_page,
    search,
    filters = {},
  }: DefaultGetRequestParams) {
    const response = await api.get<DefaultResponse<IntranetServiceOrder>>(
      "/service_order",
      {
        params: {
          page,
          per_page,
          search,
          ...filters,
        },
      },
    );
    return response.data;
  },

  async store(data: StoreServiceOrderRequest) {
    const response = await api.post<DefaultResponse<IntranetServiceOrder>>(
      "/service_order",
      data,
    );
    return response.data;
  },
};
